export default {
    state: {
        currentPage: null,
        currentSection: null,
        pageTitle: null,
        isMenuOpen: true,
        isMenuOnHover: false,
        actionTitle: null,
        actionDisabled: false,
        showAction: false,
        controlsComponent: null,
        controlsComponentProps: null,
        controlsComponentEvents: null,
        isSiteLoading: false
    },
    mutations: {
        clear: (state) => {
            state.currentPage = null;
            state.currentSection = null;
            state.pageTitle = null;
            state.actionTitle = null;
            state.actionDisabled = false;
            state.showAction = false;
            state.controlsComponent = null;
            state.controlsComponentProps = null;
            state.controlsComponentEvents = null;
        },
        setCurrentPageAndSection(state, { currentPage, currentSection }) {
            state.currentPage = currentPage;
            state.currentSection = currentSection;
        },
        setCurrentPage: (state, currentPage) => {
            state.currentPage = currentPage;
        },
        setCurrentSection: (state, currentSection) => {
            state.currentSection = currentSection;
        },
        setPageTitle: (state, pageTitle) => {
            state.pageTitle = pageTitle;
        },
        setIsMenuOpen: (state, isMenuOpen) => {
            state.isMenuOpen = isMenuOpen;
        },
        setIsMenuOnHover: (state, isMenuOnHover) => {
            state.isMenuOnHover = isMenuOnHover;
        },
        setIsSiteLoading: (state, isSiteLoading) => {
            state.isSiteLoading = isSiteLoading;
        },
        setPage(state,
            {
                pageTitle,
                actionTitle = null,
                actionDisabled = null,
                showAction = null,
                controlsComponent = null,
                controlsComponentProps = null,
                controlsComponentEvents = null
            }) {
            state.pageTitle = pageTitle;
            state.actionTitle = actionTitle;
            state.actionDisabled = actionDisabled;
            state.showAction = showAction;
            state.controlsComponent = controlsComponent;
            state.controlsComponentProps = controlsComponentProps;
            state.controlsComponentEvents = controlsComponentEvents;
        },
        setControlsComponentProps: (state, controlsComponentProps) => {
            state.controlsComponentProps = controlsComponentProps;
        }
    },
    getters: {
        currentPage: (state) => state.currentPage,
        currentSection: (state) => state.currentSection,
        pageTitle: (state) => state.pageTitle,
        actionTitle: (state) => state.actionTitle,
        actionDisabled: (state) => state.actionDisabled,
        showAction: (state) => state.showAction,
        controlsComponent: (state) => state.controlsComponent,
        controlsComponentProps: (state) => state.controlsComponentProps,
        controlsComponentEvents: (state) => state.controlsComponentEvents,
        isMenuOpen: (state) => state.isMenuOpen,
        isMenuOnHover: (state) => state.isMenuOnHover,
        isSiteLoading: (state) => state.isSiteLoading
    }
};
